// Character truncation
export const MAX_CHARACTER_TRUNCATE = 16;

// Index constants
export const FIRST_INDEX = 0;
export const SECOND_INDEX = 1;
